export default __webpack_public_path__ + "static/media/logo-bmw-rio.03bda972.svg";